import AppPicture from '@/components/app-picture'
import AppGalleryWidget from '@/components/app-gallery-widget'
import AppVisualListWidget from '@/components/app-visual-list-widget'
import AppContentGlobe from '@/components/app-content-globe'
import AppPlayerSimple from '@/components/app-player-simple'
import AppParallax from '@/components/app-parallax'
import AppScrollReveal from '@/components/app-scroll-reveal'

import EventHubMixin from '@/mixins/EventHub.js'

export default
{
    name: 'app-content',

    mixins:
    [
        EventHubMixin
    ],

    components:
    {
        AppPicture,
        AppVisualListWidget,
        AppGalleryWidget,
        AppContentGlobe,
        AppPlayerSimple,
        AppParallax,
        AppScrollReveal
    },

    props:
    {
        content: { type: Array, default: () => [] }
    },

    created()
    {
        // let haveToLoadThree = true
        // for(let i = 0; i < this.content.length; i += 1)
        // {
        //     const content = this.content[i]

        //     if(content.type.value === 'special' && content.special_type.value === 'globe')
        //     {
        //         content.haveToLoadThree = haveToLoadThree
        //         haveToLoadThree = false
        //     }
        // }

        // this.$eventHub.$on('content.threeIsLoaded', this._launchTHREE)
    },

    destroyed()
    {
        // this.$eventHub.$off('content.threeIsLoaded', this._launchTHREE)
    },

    methods:
    {
        // _launchTHREE()
        // {
        //     this.$eventHub.$emit('globe.canLaunchThree')
        // }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-content/script.js